import { render, staticRenderFns } from "./userDashboardNutritionMealPlanForm.vue?vue&type=template&id=67595786"
import script from "./userDashboardNutritionMealPlanForm.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionMealPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports